
























































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import notEmptyFun from '../../utils/notEmptyFun';
import Loading from '../../components/Loading.vue';
import tableModel from '../../components/table/tableModel.vue';

@Component({
  components: {
    Loading,
    tableModel,
  },
})
export default class WebsiteInfo extends Vue {
  private user: any;
  private spinning: boolean = false;
  private dataJson: any = [];
  private domainJson: any = []; // 多少domain, select 用
  private selectDomain: string = '';
  private isDomain: boolean = false;
  private isWebsiteInfo: boolean = false;
  private domainInfo: any = {
    domain: '',
    email: '',
    logo: '',
    banner: '',
    corporate_name: '',
    locates: '',
    telephone: '',
  };
  private websiteJson: any = {
    asin: '',
    title: '',
    amazon_Link: '',
    amazon_Pic1: '',
    amazon_Pic2: '',
    amazon_Pic3: '',
    amazon_Pic4: '',
    amazon_Pic5: '',
    amazon_Pic6: '',
    amazon_Pic7: '',
    amazon_5Describe: '',
    amazon_asinDetail: '',
  };
  private domainColumns: any = [{
      title: '域名',
      dataIndex: 'domain',
      width: '3%',
      scopedSlots: { customRender: 'domain' },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: '5%',
      scopedSlots: { customRender: 'email' },
    },
    {
      title: 'LOGO',
      dataIndex: 'logo',
      width: '5%',
      scopedSlots: { customRender: 'logo' },
    },
    {
      title: 'Banner',
      dataIndex: 'banner',
      width: '5%',
      scopedSlots: { customRender: 'banner' },
    },
    {
      title: '公司名称',
      dataIndex: 'corporate_name',
      width: '3%',
      scopedSlots: { customRender: 'corporate_name' },
    },
    {
      title: '地址',
      dataIndex: 'locates',
      width: '5%',
      ellipsis: true,
      scopedSlots: { customRender: 'locates' },
    },
    {
      title: '电话',
      dataIndex: 'telephone',
      width: '3%',
      scopedSlots: { customRender: 'telephone' },
    },
  ];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.getDomain();
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private goProductList() {
    this.$router.push({
      path: '/official/DomainAsinInfo',
    });
  }
  private addButton(type: string) {
    if (type === 'domain') {
      this.isWebsiteInfo = false;
      this.isDomain = true;
    } else if (type === 'websiteInfo') {
      this.isWebsiteInfo = true;
      this.isDomain = false;
    }
  }
  private saveDomain() {
    const that = this;
    const arr = [ 'domain', 'email', 'logo', 'banner', 'corporate_name', 'locates', 'telephone'];
    const domainInfo = this.domainInfo;
    if (!notEmptyFun(domainInfo, arr)) {
      this.$message.warning('*必填字段不能为空!!!');
      return false;
    }
    if (!this.domainReg(domainInfo.domain) || !this.domainReg(domainInfo.domain)) {
      return false;
    }
    this.emailReg(domainInfo.email);
    const url: string = '/api/saveDomain';
    const args = {};
    Object.assign(args, domainInfo, {team: this.user.team });
    this.axios.post(url, args).then((res) => {
      if (res.data.code === 12 ) {
        that.$message.success('域名信息添加成功!!!');
        const reResetJson = {
          domain: '',
          email: '',
          corporate_name: '',
          locates: '',
          telephone: '',
        };
        that.domainInfo = that.toReset(reResetJson);
        that.getDomain();
      } else if (res.data.code === 9 ) {
        that.$message.error(res.data.msg.sqlMessage);
      }
    }).catch((err) => {
      console.log(err);
      that.$message.error('error  ' + err);
      that.spinning = false;
    });
  }
  private domainReg(str: string) {
    const reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
    if (reg.test(str)) {
      return true;
    } else {
      this.$message.warning('请检查域名是否正确!!!');
      return false;
    }
  }
  private emailReg(str: string) {
    const reg = /^[a-z]([a-z0-9]*[-_]?[a-z0-9]+)*@([a-z0-9]*[-_]?[a-z0-9]+)+[\.][a-z]{2,3}([\.][a-z]{2})?$/i;
    if (reg.test(str)) {
      return true;
    } else {
      this.$message.warning('请检查邮箱名称是否正确!!!');
      return false;
    }
  }
  private toReset(reResetJson: any) {
    return Object.assign({}, reResetJson);
  }
  private saveWebsiteInfo() {
    const that = this;
    if (this.selectDomain === '') {
      this.$message.warning('请选择asin相对应域名!!!');
      return false;
    }
    const arr = ['asin', 'title', 'amazon_Link', 'amazon_Pic1', 'amazon_Pic2', 'amazon_Pic3', 'amazon_5Describe'];
    const websiteJson = this.websiteJson;
    if (!notEmptyFun(websiteJson, arr) || this.selectDomain === '') {
      this.$message.warning('*必填字段不能为空!!!');
      return false;
    }
    const url: string = '/api/saveWebsiteInfo';
    const args = {};
    Object.assign(args, websiteJson, {team: this.user.team, domain: this.selectDomain});
    this.axios.post(url, args).then((res) => {
      if (res.data.code === 12 ) {
        that.$message.success('产品添加成功!!!');
        const reResetJson = {
          asin: '',
          title: '',
          amazon_Link: '',
          amazon_Pic1: '',
          amazon_Pic2: '',
          amazon_Pic3: '',
          amazon_Pic4: '',
          amazon_Pic5: '',
          amazon_Pic6: '',
          amazon_Pic7: '',
          amazon_5Describe: '',
          amazon_asinDetail: '',
        };
        that.websiteJson = that.toReset(reResetJson);
      } else if (res.data.code === 9 ) {
        that.$message.error(res.data.msg.sqlMessage);
      }
      that.spinning = false;
    }).catch((err) => {
      console.log(err);
      that.$message.error('error  ' + err);
      that.spinning = false;
    });

  }
  private getDomain() {
    const that = this;
    const url: string = '/api/getDomain';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      if (res.data.code === 12 ) {
        const data = res.data.data;
        that.domainJson = data;
        if (data && data.length > 0) {
          that.selectDomain = data[0].domain;
        }
      } else if (res.data.code === 9 ) {
        that.$message.error(res.data.msg.sqlMessage);
      }
      that.spinning = false;
    }).catch((err) => {
      console.log(err);
      that.$message.error('error  ' + err);
      that.spinning = false;
    });
  }
  private saveAccount(): any {
    const that = this;
    this.spinning = true;
    const url: string = '/api/saveAccount';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      if (res.data.code === 12 ) {
        that.$message.success('域名信息添加成功!!!');
      } else if (res.data.code === 9 ) {
        that.$message.error(res.data.msg.sqlMessage);
      }
      that.spinning = false;
    }).catch((err) => {
      console.log(err);
      that.$message.error('error  ' + err);
      that.spinning = false;
    });
  }

}
